import React from "react";
import { Button, IconButton, Tooltip } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import useStyles from "./styles";
import { childAge, relativeDue } from "./crmService";
import { ContactButtons, StatusDot, initials } from "./crmUi";

/** One enquiry as a card row: who, due when, status, and Call / WhatsApp / Log. */
export default function EnquiryCard({ enquiry: e, tz, onOpen, onLog, noFollowUpDays }) {
  const classes = useStyles();
  const age = childAge(e);
  const child = [e.childName, age && `${age}`].filter(Boolean).join(", ");
  const dueClass =
    e.dueState === "overdue" ? classes.dueOverdue : e.dueState === "today" ? classes.dueToday : classes.dueUpcoming;
  return (
    <li className={classes.card}>
      <div className={classes.avatar} aria-hidden>
        {initials(e.parentName || e.childName)}
      </div>
      <div
        className={classes.cardMain}
        role="link"
        tabIndex={0}
        onClick={onOpen}
        onKeyDown={(ev) => ev.key === "Enter" && onOpen()}
      >
        <div className={classes.cardName}>
          {e.parentName || "No name"}
          {child && <span style={{ fontWeight: 400, color: "#555" }}> · {child}</span>}
        </div>
        <div className={classes.cardMeta}>
          {e.nextFollowUpDate && e.dueState && (
            <span className={`${classes.due} ${dueClass}`}>{relativeDue(e.nextFollowUpDate, tz)}</span>
          )}
          <StatusDot status={e.status} />
          {e.program && <span>{e.program}</span>}
          {e.assignedTo && <span>{e.assignedTo}</span>}
          {e.isStale && (
            <span className={classes.staleTag}>
              {e.hasFollowUp ? `No follow-up for ${e.daysSinceFollowUp} days` : `Not contacted in ${e.daysSinceFollowUp}+ days`}
            </span>
          )}
          {!e.isStale && !e.hasFollowUp && e.status === "New" && noFollowUpDays && <span>Not contacted yet</span>}
        </div>
      </div>
      <div className={classes.cardActions}>
        <ContactButtons enquiry={e} />
        <Button variant="outlined" size="small" onClick={onLog} style={{ marginLeft: 4 }}>
          Log
        </Button>
        <Tooltip title="Open">
          <IconButton className={classes.iconBtn} aria-label={`Open ${e.enquiryNo}`} onClick={onOpen}>
            <ChevronRightIcon />
          </IconButton>
        </Tooltip>
      </div>
    </li>
  );
}
